import { useContext } from 'react';
import { BaleCreateContext } from './context';

export const useBaleCreateContext = () => {
	const context = useContext(BaleCreateContext);
	if (!context) {
		throw new Error('useBaleCreateContext must be used within a BaleCreateContextProvider');
	}
	return context;
};
